import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscribedUser } from "../../../Pages/SubscribedUser/ISubscribedUser";

const initialState: IReduxState<ISubscribedUser[]> = {
    data: {
        data: [],
        status: false,
        message: ""
    },
    isLoading: false,
    error: null,
};

const ListSubscribedUserSlice = createSlice({
    name: "ListSubscribedUserSlice",
    initialState,
    reducers: {
        listSubscribedUser: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        successListSubscribedUser: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureListSubscribedUser: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    listSubscribedUser,
    successListSubscribedUser,
    failureListSubscribedUser,
} = ListSubscribedUserSlice.actions;

export default ListSubscribedUserSlice.reducer;
